import EfIcon from '@elem/ui/ef-icon';
import EfLink from '@elem/ui/ef-link';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

export default function TheComp() {
    const { locale, pathname } = getLocal();
    const { t } = useLang('theProduct.SectionD');
    const listA = [
        {
            icon: <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722483771549/section_d1.png" />,
            title: t('item1_title'),
            descList: [
                t.rich('item1_desc1', {
                    strong: (text: string) => <span className="a-font-weight">{text}</span>,
                }),
            ],
            btnText: t('item1_btn'),
            btnLink: `https://${locale}.ecoflow.com/pages/trade-in`,
        },
        {
            icon: <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722483771764/section_d2.png" />,
            title: t('item2_title'),
            descList: [
                t.rich('item2_desc1', {
                    strong: (text: string) => <span className="a-font-weight">{text}</span>,
                }),
                t.rich('item2_desc2', {
                    strong: (text: string) => <span className="a-font-weight">{text}</span>,
                }),
                t.rich('item2_desc3', {
                    strong: (text: string) => <span className="a-font-weight">{text}</span>,
                }),
            ],
            btnText: '',
            btnLink: '',
        },
        {
            icon: <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1722483771960/section_d3.png" />,
            title: t('item3_title'),
            descList: [t('item3_desc1')],
            btnText: t('item3_btn'),
            btnLink: '#section-SectionH',
        },
    ];

    return (
        <div className={styles.TheComp2}>
            {listA.map((item: any, index: number) => (
                <div key={index} className="ListA-item">
                    <div className="ListA-item-icon">{item.icon}</div>
                    <div className="ListA-item-title">{item.title}</div>
                    <div className="ListA-item-desc-box">
                        {item.descList?.map((desc: string, index2: number) => (
                            <div key={index2} className="ListA-item-desc">
                                {desc}
                            </div>
                        ))}
                    </div>
                    {item.btnLink && (
                        <EfLink
                            href={item.btnLink}
                            className="ListA-item-link thePage-btn"
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'activity_button',
                                page_name: pathname,
                                list_name: item.title,
                                button_name: item.btnText,
                                function: 'Release commemoration campaign',
                            }}
                        >
                            {item.btnText}
                        </EfLink>
                    )}
                </div>
            ))}
        </div>
    );
}
